// /* eslint-disable */
// /* Build style-sheets */
import './main.scss';

import "@kaena1/mm-ui-theme-v3/styles.css";
import "./13_webComponents/React/v3ComponentLibTest";
import "./10_datatracking/_dataTrackingFooter";

// atoms
const rocketFox = () =>
  import(/* webpackChunkName: "rocketFox" */ './2_atoms/_rocket-fox.js');
// molecules
const readMore = () =>
  import(/* webpackChunkName: "readMore" */ './3_molecules/_readMore.js');
const quantity = () =>
  import(/* webpackChunkName: "quantity" */ './3_molecules/_quantity.js'); // for mintech
const tooltip = () =>
  import(/* webpackChunkName: "tooltip" */ './3_molecules/_tooltip.js');
const collapse = () =>
	import(/* webpackChunkName: "collapse" */ './3_molecules/_collapse.js');
const modal = () =>
	import(/* webpackChunkName: "modal" */ './3_molecules/_modal.js');
const smsSignup = () =>
  import(/* webpackChunkName: "smsSignup" */ './3_molecules/_smsSignup.js');
const dnssModal = () =>
  import(/* webpackChunkName: "dnssModal" */ './3_molecules/_dnssModal.js');

// organisms
const faqPage = () =>
  import(/* webpackChunkName: "faqPage" */ './4_organisms/_faq.js');

// Page Specific
const plans = () =>
  import(/* webpackChunkName: "plans" */ './12_pages/_plans.js');
const featureFunctions = () =>
  import(/* webpackChunkName: "featureFunctions" */ './12_pages/_features.js');
const starter = () =>
  import(/* webpackChunkName: "starter" */ "./12_pages/_starter.js");
const handleOverLap = () => 
  import(/* webpackChunkName: "handleOverLap" */ "./12_pages/_esimOverLap.js");
const coverage = () => 
  import(/* webpackChunkName: "coverage" */ "./12_pages/_coverage.js");
const orderSummary = () => 
  import(/* webpackChunkName: "orderSummary" */ "./12_pages/_orderSummary")

// layouts
const cartFunctions = () =>
  import(/* webpackChunkName: "cartFunctions" */ './7_layouts/_cart.js');
const checkoutFunctions = () =>
  import(/* webpackChunkName: "checkoutFunctions" */ './7_layouts/_checkout.js');
const helpCenter = () => 
  import(/* webpackChunkName: "helpCenter" */ './12_pages/helpCenter/_helpCenter.js');
const helpCenterArticle = () => 
  import(/* webpackChunkName: "helpCenterArticle" */ './12_pages/helpCenter/_singleArticle.js');
const helpCenterVideoModule = () =>
  import(/* webpackChunkName: "helpCenterVideoModule" */ './12_pages/helpCenter/_helpCenterVideoModule.js');
const helpCenterNavigation = () => 
  import(/* webpackChunkName: "helpCenterNavigation" */ './12_pages/helpCenter/_helpCenterCategoryNav.js');

const tabbedPanel = () => 
  import(/* webpackChunkName: "tabbedPanel" */ './12_pages/helpCenter/_tabbedPanel.js');

const helpCenterHelpfulArticle = () =>
	import(/* webpackChunkName: "helpCenterHelpfulArticle" */ './12_pages/helpCenter/_helpCenterHelpfulArticle.js');

const siteSearch = () => 
  import(/* webpackChunkName: "siteSearch" */ './12_pages/helpCenter/_searchDataLayer.js');

// vendors
const webp = () =>
  import(/* webpackChunkName: "webp" */ './8_vendors/_webp');
const lity = () =>
  import(/* webpackChunkName: "lity" */ './8_vendors/_lity');
const ultimateFaqs = () =>
  import(/* webpackChunkName: "faq" */ './8_vendors/_ultimateFaqs.js');
const videolist = () =>
  import(/* webpackChunkName: "videolist" */ './8_vendors/_videolist.js');
const carouselIntersection = () =>
	import(
		/* webpackChunkName: "carouselIntersection" */ './9_carousels/_carouselIntersection.js'
	);

const rrCarousels = () =>
  import(/* webpackChunkName: "rrCarousels" */ './9_carousels/_rrCarousels.js');
const plansPromotionCarousel = () =>
  // MM-69 Promotion
  import(/* webpackChunkName: "plansPromotionCarousel" */ './9_carousels/_plansPromotionCarousel.js');
const homePromotionCarousel = () =>
  // MM-69 Promotion
  import(/* webpackChunkName: "homePromotionCarousel" */ './9_carousels/_homePromotionCarousel.js');
const phonesCarousels = () =>
  import(/* webpackChunkName: "phones carousels" */ './9_carousels/_phonesCarousels.js');
const featuresCarousels = () =>
  import(/* webpackChunkName: "features carousels" */ './9_carousels/_featuresCarousel.js');
const pillsCarousel = () =>
  import(/* webpackChunkName: "pills carousels" */ './9_carousels/_pillsCarousel.js');
const plansCarousels = () =>
  import(/* webpackChunkName: "plansCarousels" */ './9_carousels/_plansCarousels.js');
const plansNoCTACarousel = () =>
  import(/* webpackChunkName: "plansNoCTACarousel" */ './9_carousels/_plansNoCTACarousel.js');
const careerCarousels = () =>
  import(/* webpackChunkName: "careerCarousels" */ './9_carousels/_careerCarousels.js');
const starterCarousels = () =>
  import(/* webpackChunkName: "starterCarousels" */ './9_carousels/_starterCarousels.js');
const videoCarousels = () =>
  import(/* webpackChunkName: "videoCarousels" */ './9_carousels/_videoCarousels.js');
const fiveGCarousels = () =>
  import(/* webpackChunkName: "fiveGCarousels" */ './9_carousels/_fiveGCarousels.js');
const reviewsCarousel = () =>
  import(/* webpackChunkName: "reviewsCarousel" */ './9_carousels/_reviewsCarousel.js');
const swiperReviewsCarousel = () =>
	import(
		/* webpackChunkName: "swiperReviewsCarousel" */ './9_carousels/_swiperReviewsCarousel.js'
	);
const itemsCarousel = () =>
  import(/* webpackChunkName: "itemsCarousel" */ './9_carousels/_itemsCarousel.js');
const announcemintCarousel = () =>
  import(/* webpackChunkName: "announcemintCarousel" */ './9_carousels/_announcemintCarousel.js');
const reputationCarousel = () =>
  import(/* webpackChunkName: "reputationCarousel" */ './9_carousels/_reputationCarousel.js');
const wireless55Carousel = () =>
  import(/* webpackChunkName: "wireless55Carousel" */ './9_carousels/_wireless55Carousel.js');

// Tracking
const dataTrackingOrderStatus = () =>
  import(/* webpackChunkName: "dataTrackingOrderStatus" */ './10_datatracking/_dataTrackingOrderStatus.js');
const dataTrackingCheckoutV3 = () =>
  import(/* webpackChunkName: "dataTrackingCheckoutV3" */ './10_datatracking/_dataTrackingCheckoutV3.js');
const dataTrackingPlanCards = () =>
  import(/* webpackChunkName: "dataTrackingPlanCards" */ './10_datatracking/_dataTrackingPlanCards.js');
const dataTrackingPhoneCards = () =>
  import(/* webpackChunkName: "dataTrackingPhoneCards" */ './10_datatracking/_dataTrackingPhoneCards.js');
const dataTrackingHowItWorks = () =>
  import('./10_datatracking/_dataTrackingHowItWorks.js');
const dataTrackingCheckout = () =>
  import(/* webpackChunkName: "dataTrackingCheckout" */ './10_datatracking/_dataTrackingCheckout.js');

const dataTrackingVideoBox = () =>
  import(/* webpackChunkName: "dataTrackingVideoBox" */ './10_datatracking/_dataTrackingVideoBox.js');
const dataTrackingVideoCarousel = () =>
  import(/* webpackChunkName: "dataTrackingVideoCarousel" */ './10_datatracking/_dataTrackingVideoCarousel.js');
const dataTrackingPlanPDP = () =>
  import(/* webpackChunkName: "dataTrackingPlanPDP" */ './10_datatracking/_dataTrackingPlansPDP.js'); // pdp
const dataTrackingOfferCards = () =>
  import(/* webpackChunkName: "dataTrackingOfferCards" */ './10_datatracking/_dataTrackingOfferCards.js');

// Functions
const generateMobileDashes = () =>
  import(/* webpackChunkName: "generateMobileDashes" */ './11_functions/_generateMobileDashes.js');
const asPopup = () =>
  import(/* webpackChunkName: "asPopup" */ './11_functions/_asPopup.js');
const asCart = () =>
  import(/* webpackChunkName: "asCart" */ "./11_functions/_asCart.js");
const orderStatusTracking = () =>
  import(/* webpackChunkName: "orderStatusTracking" */ './11_functions/_orderStatusTracking.js');
const switchShippingOptions = () =>
  import(/* webpackChunkName: "switchShippingOptions" */ './11_functions/_switchShippingOptions.js');
const rafReferralDisplay = () =>
	import(/* webpackChunkName: "rafReferralDisplay" */ './11_functions/_rafReferralDisplay.js');

// Components
const planCalc = () =>
  import(/* webpackChunkName: "planCalc" */ './13_webComponents/React/planCalculator/PlanCalculator');
const searchFeature = () =>
  import(/* webpackChunkName: "searchFeature" */ './13_webComponents/React/search-feature/Search');
const mfp = () =>
  import(/* webpackChunkName: "mfp" */ './13_webComponents/React/mfp/src');
const howItWorks = () =>
  import(/* webpackChunkName: "howItWorks" */ './4_organisms/_howitworks');
const portInInstructionsTool = () =>
  import(/* webpackChunkName: "portInInstructionsTool" */ './13_webComponents/React/portInInstructionsTool');


// product bundle page

const affirm = () =>
  import(/* webpackChunkName: "affirm" */ './11_functions/_affirm');

// WP and Legacy V2 Scripts that will be necessary to load certain pages/functionalities
const cart = () =>
	import(/* webpackChunkName: "cart" */ '../../src/js/cart-page');

const setupFunctions = () =>
  import(/* webpackChunkName: "setupFunctions" */ './12_pages/_setup.js');
const modifyCMSSocial = () =>
  import(/* webpackChunkName: "modifyCMSSocial" */ './11_functions/modifyCMSTweet');
const centerTwoElements = () =>
  import(/* webpackChunkName: "centerTwoElements" */ './4_organisms/_centerTwoElements.js');
const bestValueCarousels = () =>
  import(/* webpackChunkName: "bestValueCarousels" */ './9_carousels/_bestValueCarousels.js');

const returnPolicy = () =>
  import(/* webpackChunkname: "returnPolicy" */ './12_pages/_returnpolicy.js');
const savingsQuiz = () =>
  import(/* webpackChunkname: "savingsQuiz" */ './12_pages/_savingsQuiz');
const esimExchange = () =>
  import(/* webpackChunkname: "esimExchange" */ './12_pages/_esimExchange.js');
const esimLP = () =>
  import(/* webpackChunkname: "esimLp" */ './12_pages/_esimLP.js');
const greenHouseJobsBoard  = ()=>
  import(/* webpackChunkname: "greenHouseJobsBoard" */ './11_functions/_greenHouseJobs.js');

const phoneCompatibility = () =>
  import(/* webpackChunkname: "phoneCompatibility" */ './12_pages/_phoneCompatibility.js');
const checkoutPage = () =>
  import(/* webpackChunkname: "checkoutPage" */ './12_pages/checkout/_checkoutv3.js')
const bestValueWirelessPage = () =>
  import(/* webpackChunkname: "bestValueWirelessPage" */ './12_pages/_bestValueWireless');
const orderLookup = () =>
  import(/* webpackChunkName: "orderLookup" */ "./12_pages/_orderLookup.js");
const dataTrackingOrderStatusSummary  = ()=>
  import(/* webpackChunkname: "dataTrackingOrderStatusSummary" */ './10_datatracking/_dataTrackingOrderStatusSummary.js');
const seniorReviewCarousels = () => import(/* webpackChunkName: "seniorReviewCarousels" */ './9_carousels/_seniorReviewCarousels.js');
const articleCarousel = () => import(/* webpackChunkName: "articleCarousel" */ './9_carousels/_ArticleCarousel.js');
const globalScripts = () => import(/* webpackChunkName: "globalScripts" */'./12_pages/global/_global');
const ctaTracking  = ()=>{
	import (/* webpackChunkname: "ctaTracking" */ './10_datatracking/_ctaTracking.js');
}

const inThisArticle = () => import(/* webpackChunkName: "inThisArticle" */'./12_pages/blog/_inThisArticle');

const blogCategoryNav = () => import(/* webpackChunkName: "blogCategoryNav" */'./12_pages/blog/_blogCategoryNav');

const blogArticlePage = () => import(/* webpackChunkName: "blogArticlePage" */'./12_pages/blog/_blogArticlePage.js');

const blogHelpfulArticle = () =>
	import(/* webpackChunkName: "blogHelpfulArticle" */ './12_pages/blog/_blogHelpfulArticle.js');

const dataTrackingBonusLandingPage  = ()=>{
	import (/* webpackChunkname: "dataTrackingBonusLandingPage" */ './10_datatracking/_dataTrackingBonusLandingPage.js');
}


const checkoutErrorCapture = () =>
  import(/* webpackChunkname: "checkoutErrorCapture" */ './12_pages/checkout/_checkoutErrorCapture.js');
const returningPaypalCustomer = () =>
  import(/* webpackChunkname: "returningPaypalCustomer" */ './12_pages/checkout/_returningPaypalCustomer.js');

const checkoutRefresh  = ()=>{
	import (/* webpackChunkname: "thankyouRefresh" */ './12_pages/checkout/_checkoutRefresh.js');
}

const invocaScript  = ()=>{
	import (/* webpackChunkname: "invocaScript" */ './11_functions/_invocaScript.js');
}

if (window.page === 'target') {
  lity();
}

if (window.page === 'how-it-works-compatibility') {
  generateMobileDashes();
}

if (window.page === 'how-it-works-plans') {
  generateMobileDashes();
}

if (window.page === 'how-it-works-activation') {
  generateMobileDashes();
  lity();
}

if (window.page === 'rr') {
  planCalc();
  rrCarousels();
  announcemintCarousel();
  dataTrackingVideoCarousel();
  lity();
  modifyCMSSocial();
}

if (window.page === 'plan_calc') {
  planCalc();
}

if (window.page === 'compatibility') {
  dataTrackingHowItWorks();
  phoneCompatibility();
}

if (window.page === 'umts') {
  phonesCarousels();
}

if (window.page === 'plans') {
  plansCarousels();
  dataTrackingPlanCards();
  plans();
  rocketFox();
  tooltip();
  webp();
  plansPromotionCarousel();
  planCalc();
}

if (window.page === 'nationalRetail') {
  tooltip();
}

if (window.page === 'product') {
	quantity(); // quantity js for minttech page
	dataTrackingPlanPDP(); // js for minttech page 
}


if (window.page === 'checkout') {
	checkoutPage();
  dataTrackingCheckoutV3();
  checkoutErrorCapture();
  returningPaypalCustomer();
  checkoutRefresh();
}

if (window.page === 'cart') {
	cart();
	cartFunctions();
	tooltip();
	asPopup();
	asCart();
	switchShippingOptions();
	collapse();
	modal();
  rafReferralDisplay();
}

if (window.page === '5G' ) {
  fiveGCarousels();
  swiperReviewsCarousel();
  dataTrackingPlanCards();
  dataTrackingPhoneCards();
  tooltip();
}

if (window.page === 'careers') {
  careerCarousels();
  greenHouseJobsBoard();
}

if (window.page === 'starter') {
  starterCarousels();
  carouselIntersection();
  starter();
  tooltip();
  webp();
  swiperReviewsCarousel();
}

if (window.page === 'faq') {
  faqPage();
  pillsCarousel();
  videoCarousels();
}

if (window.page === 'target') {
  videoCarousels();
  dataTrackingVideoCarousel();
  lity();
}

if (window.page === 'features') {
  featureFunctions();
  searchFeature();
  featuresCarousels();
  tooltip();
  lity();
  dataTrackingPhoneCards();
  lity();
}

if (window.page === 'setup') {
	setupFunctions();
	videoCarousels();
  tooltip();
}


if (window.page === 'reviews') {
	reviewsCarousel();
	swiperReviewsCarousel();
}


if (window.page === 'returnpolicy') {
  returnPolicy();
}

if (window.globalScripts === 'true') {
	globalScripts();
}

if (window.page === 'mfp') {
  mfp();
  fiveGCarousels();
  swiperReviewsCarousel();
  dataTrackingPlanCards();
  tooltip();
}

if (window.page === 'bestvalue') {
  centerTwoElements();
  bestValueCarousels();
  bestValueWirelessPage();
  tooltip();
  plans();
  plansCarousels();
}

if (window.page === 'reviews') {
  itemsCarousel();
}
if (window.page === 'savings-quiz') {
  savingsQuiz();
}

if (window.page === 'esim-exchange') {
  esimExchange();
}

if (window.page === 'esim-lp') {
  itemsCarousel();
  lity();
  dataTrackingVideoBox();
  tooltip();
  esimLP();
  dataTrackingPlanCards();
}

if (
  window.page === 'order-lookup'
  || window.page === 'order-status'
) {
  orderLookup();
  orderSummary();
    dataTrackingOrderStatusSummary();
  orderStatusTracking();
}

if (window.page === 'order-status'){
  dataTrackingOrderStatus();
}



if (
  window.page === 'plans'
  || window.page === 'product'
  || window.page === 'device-product'
  || window.page === 'device-bundle'
  || window.page === '5G'
  || window.page === 'umts'
  || window.page === 'LP'
  || window.page === 'raf'
  || window.page === 'returnpolicy'
  || window.page === 'target'
  || window.page === 'esim-lp'
  || window.page === 'esim-returns'
  || window.page === 'welcome-to-mint-mobile'
  || window.page === 'psim-setup'
  || window.page === 'mfp'
  || window.page === 'bestvalue'

) {
  ultimateFaqs();
}



if (window.page === 'coverage') {
  coverage();
	seniorReviewCarousels();
  articleCarousel();
  swiperReviewsCarousel();
  ultimateFaqs();
  dataTrackingPhoneCards();
}

if (window.page === 'why-choose-mint-mobile') {
	articleCarousel();
	lity();
}

if (window.page === 'switch-to-mint') {
	lity();
  articleCarousel();
}

if (window.page === 'welcome-to-mint-mobile') {
	videolist();
	setupFunctions();
	videoCarousels();
  tooltip();
}

if (window.page === 'psim-setup') {
	videolist();
	setupFunctions();
	videoCarousels();
  tooltip();
}

if (window.page === 'unliminted'){
	rocketFox();
}

if(window.page === 'blog') {
	blogCategoryNav();
  siteSearch();
}

if (window.page === 'blog-article') {
	inThisArticle();
	blogCategoryNav();
  ctaTracking();
  blogArticlePage();
  portInInstructionsTool();
  siteSearch();
  blogHelpfulArticle();
}

if(window.page ==='home'){
  dataTrackingBonusLandingPage();
}

if (window.page === 'help-center' || window.page === 'help-center-category' ){
  lity();
  helpCenter();
  helpCenterNavigation();
  siteSearch();
}

if (window.page === 'help-center') {
  helpCenterVideoModule();  
  invocaScript();
}

if (window.page === 'help-center-article'){
  helpCenterArticle();
  helpCenterNavigation();
  tabbedPanel();
	helpCenterHelpfulArticle();
  portInInstructionsTool();
  siteSearch();
}

if (window.page === 'help-center-search') {
  siteSearch();
  lity();
}

if(window.page == 'black-friday-deals') {
  readMore();
}

if (window.page == 'reviews3') {
  swiperReviewsCarousel();
  ultimateFaqs();
  lity();
}

if (window.page === 'sms-signup') {
  smsSignup();
}

dnssModal().then(module => {module.default();});